export default function Upload({ color = '#989898' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="51.716" height="83.05" viewBox="0 0 51.716 83.05">
      <path id="Union_196" data-name="Union 196" d="M2,83.051a2,2,0,0,1-2-2V74.277a2,2,0,0,1,2-2H49.717a2,2,0,0,1,2,2v6.774a2,2,0,0,1-2,2ZM22.9,65.813a2,2,0,0,1-2-2V15.632L9.693,27.261a4.3,4.3,0,0,1-6.244,0,4.7,4.7,0,0,1,0-6.479L22.184,1.344A4.317,4.317,0,0,1,25.654.015a4.316,4.316,0,0,1,3.469,1.328L47.859,20.782a4.7,4.7,0,0,1,0,6.479,4.3,4.3,0,0,1-6.247,0L30.4,15.633V63.814a2,2,0,0,1-2,2Z" transform="translate(-0.001 -0.001)" fill={color} />
    </svg>

  );
}
